import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import actionTypes from 'store/table/actionTypes1';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  setTable as setTableAction,
  setLegenda as setLegendaAction,
} from '../actions';
import {
  getBb, getCard1, getCard2, getSuit, getStake, getTs, getCard3, getCard4, getSuitQuality, getGgps,
} from '../selectors';

export function* setTableGen(payload) {
  try {
    const card1 = yield select(getCard1);
    const card2 = yield select(getCard2);
    const card3 = yield select(getCard3);
    const card4 = yield select(getCard4);
    const ts = yield select(getTs);
    const stake = yield select(getStake);
    const bb = yield select(getBb);
    const suit = yield select(getSuit);
    const suitQuality = yield select(getSuitQuality);
    const ggps = yield select(getGgps);
    const res = yield call(api, {
      method: 'post',
      url: sessionStorage.getItem('isPlo5') === 'true' ? URL.PLO5COMBINATION : URL.COMBINATION,
      data: {
        card1,
        card2,
        card3,
        card4,
        ts,
        stake,
        // eslint-disable-next-line no-nested-ternary
        bb: ts !== 'mtt' ? (stake.includes('0') ? 'rfivssqz' : bb) : `${bb}potopen`,
        suit,
        game: payload.gameTable,
        goodsuit: suitQuality === 'double',
        gg: ggps === 'gg',
      },
    });
    yield put(setTableAction.success({
      cardCombinations: res?.data?.combinations,
      highestCard: res?.data?.highest,
    }));
    yield put(setLegendaAction.success({
      legenda: res?.data?.legenda?.colors,
      doubleColor: res?.data?.legenda?.double_color,
      easyLegenda: res?.data?.easy_legenda?.colors,
      easyDoubleColor: res?.data?.easy_legenda?.double_color,
    }));
    // eslint-disable-next-line no-empty
  } catch (e) {
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_TABLE, setTableGen);
}
